import React from 'react';

import Tooltip from 'components/mui/Tooltip';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';

const ApprovalsAvatarGroup = ({ maxAvatars = 3, approvers, sx, ...rest }) => (
  <AvatarGroup
    max={maxAvatars}
    sx={{
      '& .MuiAvatar-root': { width: 24, height: 24, fontSize: 15 },
      '& .MuiAvatar-root:nth-of-type(1)': {
        zIndex: approvers.length,
      },
      flex: '0 0 auto',
      ...sx,
    }}
    {...rest}
  >
    {approvers.map((a, j) => (
      <Tooltip key={a.id} t={a.fullName}>
        <Avatar src={a.picture} alt={a.fullName} sx={{ zIndex: j }} />
      </Tooltip>
    ))}
  </AvatarGroup>
);

export default ApprovalsAvatarGroup;
